import React from "react";
import { Helmet } from "react-helmet";

function AdRollScript() {
  // Memoized so react-helmet doesn't re-compare the element child on re-render: deep-equal@1 recurses on it (stack overflow)
  const adRollHelmet = React.useMemo(
    () => (
      <Helmet>
      <script>
        {`
          adroll_adv_id = "7HAXCLAXPNHL7DUHZJ7GQB";
          adroll_pix_id = "NDOQR6QPW5B5TFQSWTR4JP";
          adroll_version = "2.0";
          (function(w, d, e, o, a) {
            w.adroll_tag_source = w.adroll_tag_source || "manual";
            w.__adroll_loaded = true;
            w.adroll = w.adroll || [];
            w.adroll.f = ['setProperties', 'identify', 'track', 'identify_email', 'get_cookie'];
            var roundtripUrl = "https://s.adroll.com/j/" + adroll_adv_id + "/roundtrip.js";
            for (a = 0; a < w.adroll.f.length; a++) {
              w.adroll[w.adroll.f[a]] = w.adroll[w.adroll.f[a]] || (function(n) {
                return function() { w.adroll.push([n, arguments]) }
              })(w.adroll.f[a])
            }
            e = d.createElement('script');
            o = d.getElementsByTagName('script')[0];
            e.async = 1;
            e.src = roundtripUrl;
            o.parentNode.insertBefore(e, o);
          })(window, document);
          adroll.track("pageView");
        `}
      </script>
      </Helmet>
    ),
    [],
  );

  return adRollHelmet;
}

export default AdRollScript;
